module.exports = __webpack_public_path__ + "img/album18_48.2ee15c53.jpg";